import { useEffect, useState } from "react";

/**
 * Sticky 50/50 A/B test for the primary CTA copy.
 * Variant A: "Reserve Your Free Session"
 * Variant B: "Reserve Your Free Consultation"
 *
 * Persists per-browser in localStorage so each visitor sees one variant
 * consistently. Variant is also submitted with each application so we can
 * compare conversion rates later (queryable in MongoDB).
 *
 * Force a variant for QA by appending ?cta=A or ?cta=B to the URL.
 */
const KEY = "chic_cta_variant";

const COPY = {
  A: {
    full: "Reserve Your Free Session",
    short: "Reserve Your Session",
    button: "Reserve My Free Session",
  },
  B: {
    full: "Reserve Your Free Consultation",
    short: "Reserve Your Consultation",
    button: "Reserve My Free Consultation",
  },
};

export function useAbVariant() {
  const [variant, setVariant] = useState("A");

  useEffect(() => {
    let v;
    // 1. Allow URL override for testing/QA
    try {
      const params = new URLSearchParams(window.location.search);
      const forced = (params.get("cta") || "").toUpperCase();
      if (forced === "A" || forced === "B") {
        v = forced;
        localStorage.setItem(KEY, v);
      }
    } catch (_) {}

    // 2. Persisted assignment
    if (!v) v = localStorage.getItem(KEY);

    // 3. Fresh visitor → 50/50 random
    if (v !== "A" && v !== "B") {
      v = Math.random() < 0.5 ? "A" : "B";
      try {
        localStorage.setItem(KEY, v);
      } catch (_) {}
    }
    setVariant(v);
  }, []);

  return {
    variant,
    copy: COPY[variant],
  };
}

export function getStoredVariant() {
  try {
    const v = localStorage.getItem(KEY);
    return v === "A" || v === "B" ? v : null;
  } catch (_) {
    return null;
  }
}
